module.exports = __webpack_public_path__ + "img/BE0649796367.ded7eff0.png";